<script>
    import Mute from './Mute.svelte';
    import Button from './Button.svelte';
    import ButtonSpacer from './ButtonSpacer.svelte';
    import Space from './Space.svelte';
    export let state;
    const style = "flex: 0 0 auto";
    const characterToPretty = {
        "worker": "Warehouse Worker",
        "hr manager": "HR Manager",
        "ceo": "CEO",
        "call center rep": "Call Center Rep",
    };
</script>

<style lang="less">
    @import "./common.less";
    div {
        flex: 0 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-end; /* along flex-direction */
        align-items: center; /* perpendicular to flex-direction */
    }
    div + div {
        margin-top: 5px;
    }
</style>

<div>
    <Button message={{dest: state.pageIndex === 'glossary' ? 'back' : 'glossary'}} {style}>{state.pageIndex === 'glossary' ? 'Back' : 'Glossary'}</Button>
    <Button message={{dest: state.pageIndex === 'credits' ? 'back' : 'credits'}} {style}>{state.pageIndex === 'credits' ? 'Back' : 'Credits'}</Button>
    {#if (state.pageIndex !== 'home' && state.pageIndex !== 'credits') || (state.pageIndex === 'credits' && state.back[0] !== 'home')}
        <Button message={{dest: state.pageIndex === "choose your character" ? "home" : "start over?"}} {style}>{state.pageIndex === "choose your character" ? "Back" : "Start Over"}</Button>
    {/if}
    <Button tooltip={`${state.soundEnabled ? 'Disable' : "Enable"} sound`} message={{state: [['soundEnabled', '!']]}} {style}><Mute soundEnabled={state.soundEnabled}/></Button>
</div>
<div>
{#if (state.character && state.pageIndex !== `chose ${state.character}`)}
    <span>{characterToPretty[state.character]}:<Space/></span><Button message={{dest: `${state.character} bio reminder`}} {style}>Bio</Button>
    {#if (state.pageIndex !== `${state.character} mission`)}
        <Button message={{dest: `${state.character} mission reminder`}} {style}>Mission</Button>
    {/if}
{/if}
</div>